import * as echarts from "echarts";
import { useEffect } from "react";

const EChartTree = ({
  data,
  setData,
  institution_name,
  setFade,
  setSection,
}) => {
  useEffect(() => {
    const myChart = echarts.init(document.getElementById("echart-tree"));
    var option;

    function getLevelOption() {
      return [
        {
          itemStyle: {
            borderColor: "#777",
            borderWidth: 0,
            gapWidth: 1,
          },
          upperLabel: {
            show: false,
          },
        },
        {
          itemStyle: {
            borderColor: "#555",
            borderWidth: 5,
            gapWidth: 1,
          },
          emphasis: {
            itemStyle: {
              borderColor: "#A9A9A9",
            },
          },
        },
        {
          colorSaturation: [0.35, 0.5],
          itemStyle: {
            borderWidth: 5,
            gapWidth: 1,
            borderColorSaturation: 0.6,
          },
        },
      ];
    }
    myChart.setOption(
      (option = {
        // title: {
        //   text: "Disk Usage",
        //   left: "center",
        // },

        tooltip: {
          formatter: function (info) {
            var value = info.value;
            var treePathInfo = info.treePathInfo;
            var treePath = [];
            for (var i = 1; i < treePathInfo.length; i++) {
              treePath.push(treePathInfo[i].name);
            }
            return [
              '<div class="tooltip-title">' +
                echarts.format.encodeHTML(treePath.join("/")) +
                "</div>",
              "Faculty members: " + echarts.format.addCommas(value),
            ].join("");
          },
        },
        series: [
          {
            top: "1%",
            left: "2%",
            width: "96%",
            height: "94%",
            // scaleLimit: {
            //   max: 3,
            //   min: 0.8,
            // },
            // zoom: 2,
            name: `${institution_name}`,
            type: "treemap",
            visibleMin: 300,
            label: {
              show: true,
              formatter: "{b}",
            },
            upperLabel: {
              show: true,
              height: 30,
              color: "white",
            },
            itemStyle: {
              borderColor: "#fff",
            },
            levels: getLevelOption(),
            data: data.data,
          },
        ],
      })
    );
    option && myChart.setOption(option);
    myChart.on("dblclick", (param) => {
      setTimeout(() => {
        // alert(param.data.name);
        setFade("fade-out");
        setTimeout(() => {
          setSection(1);
        }, 1000);
      }, 1000);
    });
  }, []);
  return (
    <div
      id="echart-tree"
      style={{
        width: "100%",
        height: "90%",
      }}
    ></div>
  );
};

export default EChartTree;
